// Environment types
export type ConnectionEnvironment =
  | "Production"
  | "UAT"
  | "PlayTest"
  | "Local"
  | "Staging"
  | "OnPremiseUSCluster1"
  | "OnPremiseUSCluster2"
  | "OnPremiseUSCluster3"
  | "OnPremisePKCluster1"
  | "OnPremisePKCluster2"
  | "OnPremisePKCluster3"
  | "DocspireUAT"
  | "Docspire";

// Environment detection based on window.location.hostname
export const getConnectionEnvironment = (): ConnectionEnvironment => {
  const hostname = window.location.hostname;

  if (hostname === "qa-management.cloudastera.com") {
    return "UAT";
  } else if (hostname === "dev-management.cloudastera.com") {
    return "PlayTest";
  } else if (hostname === "staging-management.cloudastera.com") {
    return "Staging";
  } else if (hostname === "localhost" || hostname.includes("local")) {
    return "Local";
  } else if (hostname.includes("release1-us-management.cloudastera.com")) {
    return "OnPremiseUSCluster1";
  } else if (hostname.includes("release2-us-management.cloudastera.com")) {
    return "OnPremiseUSCluster2";
  } else if (hostname.includes("release3-us-management.cloudastera.com")) {
    return "OnPremiseUSCluster3";
  } else if (hostname.includes("release1-pk-management.cloudastera.com")) {
    return "OnPremisePKCluster1";
  } else if (hostname.includes("release2-pk-management.cloudastera.com")) {
    return "OnPremisePKCluster2";
  } else if (hostname.includes("release3-pk-management.cloudastera.com")) {
    return "OnPremisePKCluster3";
  } else if (hostname === "management.cloudastera.com") {
    return "Production";
  } else if (hostname.includes("qa-management.docspire.ai")) {
    return "DocspireUAT";
  } else if (hostname.includes("management.docspire.ai")) {
    return "Docspire";
  }
  // Default to Production
  return "DocspireUAT";
};
